module.exports = __webpack_public_path__ + "static/img/organization.d1598a3a.png";